export enum Regex {
    Email = '^[^\\s@]+@[^\\s@]+\\.[^\\s@]{2,}$'
}
